import React, { useEffect, useState } from 'react'
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import MappingEventTable from './MappingEventTable';
import Loader from '../../../component/Loader/Loader';
import Breadcrumb from '../../../component/Breadcrumb';
import MappingTabing from '../../../component/MappingTabing';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import { getDataForExistingEvents } from '../../../api/mappingApi';
import { checklocalStorageItems, saveContentFile } from '../../../utlis';

const MappingEvents = () => {

  const [showLoader, setShowLoader]     = useState(false);
  const [eventData,setEventData]        = useState([]);
  const [searchValue,setSearchValue]    = useState('');
  const [itemForLocal, setItemForLocal] = useState(false);
  const [lengthCount, setLengthCount]   = useState(0);
  const [previousHash,setPreviousHash]   = useState(() => {
    const storedEvents =  localStorage.getItem('Events');
    return storedEvents ? storedEvents : '';
  })

  useEffect(() => {
    const fetchEventData = async () => {
      let localStorageEventData = JSON.parse(localStorage.getItem('Events'));
      const newHash = (localStorageEventData != null && localStorageEventData.length > 0) ? JSON.stringify(localStorageEventData) : '';
      if(localStorageEventData != null && localStorageEventData.length > 0){
        setLengthCount(localStorageEventData.length);
        if(localStorageEventData.length !== lengthCount || previousHash !== newHash){
          const formData = new FormData();
          const jsonData = JSON.stringify(localStorageEventData);
          formData.append('file',new Blob([jsonData],{type:'application/json'}),'data.txt');
          setShowLoader(true);
          let fetchDataForExisiting = await getDataForExistingEvents(formData);
          setShowLoader(false);
          setPreviousHash(newHash);
          if(fetchDataForExisiting){
            setEventData(fetchDataForExisiting);
          }
        }
      }
    }
    const dataInLocalStorage = checklocalStorageItems();
    setItemForLocal(dataInLocalStorage);
    fetchEventData();
    window.addEventListener('storage',fetchEventData);
    return () => {
        window.removeEventListener('storage',fetchEventData);
    }
  },[lengthCount,previousHash]);
  

  const handleRowDelete = (rowIndex) => {
    const newArray = [...eventData];
    newArray.splice(rowIndex, 1);
    setEventData(newArray);
    if(newArray.length === 0){
        localStorage.removeItem("Events");
    } else {
        localStorage.setItem('Events',JSON.stringify(newArray));
    }
    const storedEvents =  localStorage.getItem('Events');
    setPreviousHash(storedEvents ? storedEvents : '');
  }

  const handleAddButton = () => {
    window.open('/events','_blank','noopener,noreferrer,width=auto,height=auto')
  } 

  const handleChangeTextValue = (e) => {
    setSearchValue(e.target.value)
  }

  const handleSearch = async () => {
    setShowLoader(true);
    let localStorageEventData = JSON.parse(localStorage.getItem('Events'));
    if(localStorageEventData != null && localStorageEventData.length > 0){
      const formData = new FormData();
      const jsonData = JSON.stringify(localStorageEventData);
      formData.append('file',new Blob([jsonData],{type:'application/json'}),'data.txt')
      let fetchDataForExisiting = await getDataForExistingEvents(formData);
      setShowLoader(false);
      if(fetchDataForExisiting){
        if(searchValue !== ''){
          let filterResults = fetchDataForExisiting.filter((data) => data.EnglishText === searchValue);
          setEventData(filterResults);
        } else {
          setEventData(fetchDataForExisiting);
        }
      }
    }
    setShowLoader(false);
  }

  const clearSearchValue = () => {
    setSearchValue('');
    setLengthCount(0);
    //fetchEventData();
  }

  const handleConfigFileContent = async() => {
    setShowLoader(true);
    const result = await saveContentFile();
    setShowLoader(false);
    if(result){
        swal({
          title: "Success",
          text: result.message,
          icon: "success",
        })
    }
  }

  return (
    <>
      {showLoader &&
        <Loader />
      }
      <Breadcrumb  title="Configuration Events">
          <Typography component={Link} to="/" color="primary" variant="subtitle2"  className="link-breadcrumb">
          Dashboard
          </Typography>
          <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
          Events
          </Typography>
      </Breadcrumb>
      <MappingTabing 
        value="event" 
        handleConfigFileContent={handleConfigFileContent}
      />
      <Box  component="section">
        <Grid className="contentBox">
          <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'space-between'}>
            <Grid item>
                <Box sx={{ ml:4,display: 'flex', alignItems: 'flex-end'}}>
                    <TextField id="input-with-sx" value={searchValue} label="Search By English Text" variant="standard" onChange={handleChangeTextValue} />
                    <SearchIcon onClick={handleSearch} sx={{cursor:'pointer', color: '#74737B', mr: 0.5,my: 0.5  }} />
                    <ClearIcon onClick={clearSearchValue} sx={{cursor:'pointer', color: '#FF413A', my: 0.5 }} />
                </Box>
            </Grid>
            {itemForLocal &&
              <Grid item sx={{mt: { xs: 2,sm:1 },pl: { xs: 4 }}}>
                  <Button
                      onClick={handleAddButton}
                      variant="contained"
                      size="small"
                      color="primary"
                      sx={{mr:3}}
                  >Add 
                  </Button>
              </Grid>
            }
          </Grid>
          {eventData.length === 0  &&
            <p>No Data Available.</p>
          }
          <MappingEventTable 
            data={eventData}
            handleRowDelete={handleRowDelete}
            setShowLoader={setShowLoader}
          />
        </Grid>
      </Box>
    </>    
  )
}

export default MappingEvents